import { ActionChip } from "@portal/components/primitives";

/**
 * Offered questions as pill actions. Renders nothing when there is nothing left to offer, so
 * callers can filter out prompts already asked without guarding the row.
 */
export const AdminAssistantSuggestions = ({
	className,
	disabled,
	onSelect,
	prompts,
	testId,
}: {
	className?: string;
	disabled?: boolean;
	onSelect: (prompt: string) => void;
	prompts: string[];
	testId: string;
}) => {
	if (prompts.length === 0) return null;

	return (
		<div className={className} data-testid={testId}>
			{prompts.map((prompt) => (
				<ActionChip
					disabled={disabled}
					key={prompt}
					onClick={() => onSelect(prompt)}
					testId="assistant-suggested-prompt"
				>
					{prompt}
				</ActionChip>
			))}
		</div>
	);
};
